export const mapMoney = (money) => {
  return money ? { Currency: money.Currency, Value: money.Value } : void 0;
};
